import React from 'react';
import { Calendar } from 'lucide-react';
import type { SurveyResponseItem } from '@clareefai/types';
import NpsScoreBadge from './NpsScoreBadge';

interface SurveyResponseCardProps {
  response: SurveyResponseItem;
  onClick: () => void;
  isSelected?: boolean;
}

const SurveyResponseCard: React.FC<SurveyResponseCardProps> = ({ response, onClick, isSelected }) => {
  const date = new Date(response.completedAt).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-xl border cursor-pointer transition-all duration-200 p-4 space-y-3 hover:shadow-md ${
        isSelected ? 'border-purple-500 shadow-md ring-1 ring-purple-500' : 'border-gray-200 hover:border-gray-300'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 text-sm truncate">{response.respondentName}</p>
          <p className="text-xs text-gray-500 truncate">{response.respondentEmail}</p>
        </div>
        <span className="flex-shrink-0 text-xs font-medium bg-indigo-100 text-indigo-700 rounded-full px-2 py-0.5">
          Promoter
        </span>
      </div>

      <div className="flex items-center gap-2">
        <NpsScoreBadge score={response.npsScore} size="sm" />
        <div>
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">NPS Score</p>
          <p className="text-xs text-gray-700">{response.npsScore}/10 Rating</p>
        </div>
      </div>

      {response.generalFeedback && (
        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">General Feedback</p>
          <p className="text-xs text-gray-700 line-clamp-2 italic">"{response.generalFeedback}"</p>
        </div>
      )}

      <div className="flex items-center gap-1.5 text-xs text-gray-400">
        <Calendar className="w-3 h-3" />
        <span>{date}</span>
      </div>
    </div>
  );
};

export default SurveyResponseCard;
